module.exports = __webpack_public_path__ + "media/images/triangle--down-ca97d6256de5de4d4efb0844fadcac04.png";